import React, { useMemo, useContext } from 'react'
import { Box, Grid, Hidden, SxProps } from '@hermes/web-components'
import { HomePageContext } from '../../../../providers/HomePage'
import { newSearchTypesPractices } from '../../../../constants/global'
import SearchResultsList, { Item } from './ResultsList'

import { SearchResultsModalRoot, SearchModalItemContainer, EmptySearchResultsContainer } from './styles'
import NoResultsComponent from './NoResultsComponent'

interface AutocompleteResultsModalProps {
  data: {
    specialties: Array<Item>
    conditionsProcedures: Array<Item>
    profiles: Array<Item>
  }
  searchString: string
  customStyle?: SxProps
  onClose: () => void
  onChangeSearch: (...params: any) => void
  isOpen: boolean
}

const AutocompleteResultsModal = ({
  data,
  searchString,
  onClose,
  customStyle,
  isOpen
}: AutocompleteResultsModalProps) => {
  const isKeywordsEmpty = useMemo(() => data?.specialties?.length && data?.conditionsProcedures?.length, [data])
  const isEmptyContent = useMemo(
    () => data.profiles.length === 0 && data.specialties.length === 0 && data.conditionsProcedures.length === 0,
    [data]
  )
  const {
    state: { filters }
  } = useContext(HomePageContext)
  const isAlternativeSearchTypesIncluded = useMemo(
    () => filters?.searchType && newSearchTypesPractices.includes(filters?.searchType),
    [filters?.searchType]
  )
  const managedContainerSizes = !isAlternativeSearchTypesIncluded ? { left: 0, right: 0 } : {}
  const managedContainerStyle = {
    ...managedContainerSizes,
    top: '110%',
    textAlign: 'start',
    display: !isOpen ? 'none' : 'block'
  }

  const handleCloseSearch = () => {
    onClose()
  }

  const listBuilder = () => {
    let content

    if (isAlternativeSearchTypesIncluded) {
      content = (
        <SearchResultsList
          rootContainerStyles={{ padding: '16px 20px' }}
          items={data?.profiles}
          specialties={data?.specialties}
          shouldShowProfiles
          specialistOrPractice
          handleCloseSearch={handleCloseSearch}
          conditionsProcedures={data?.conditionsProcedures}
          searchString={searchString}
          bubbleView
          isMobileView
        />
      )
    } else if (isEmptyContent) {
      content = (
        <SearchResultsList
          rootContainerStyles={{ padding: '16px 20px' }}
          items={data?.profiles}
          specialistOrPractice
          handleCloseSearch={handleCloseSearch}
          conditionsProcedures={data?.conditionsProcedures}
          searchString={searchString}
          shouldShowProfiles
          bubbleView
          isMobileView
        />
      )
    } else if (isKeywordsEmpty) {
      content = (
        <SearchResultsList
          rootContainerStyles={{ padding: '16px 20px' }}
          specialties={data?.specialties}
          specialistOrPractice
          handleCloseSearch={handleCloseSearch}
          conditionsProcedures={data?.conditionsProcedures}
          searchString={searchString}
          bubbleView
          isMobileView
        />
      )
    } else {
      content = (
        <SearchResultsList
          rootContainerStyles={{ padding: '16px 20px' }}
          items={data?.profiles}
          shouldShowProfiles
          specialistOrPractice
          handleCloseSearch={handleCloseSearch}
          conditionsProcedures={data?.conditionsProcedures}
          searchString={searchString}
          bubbleView
          isMobileView
        />
      )
    }

    return content
  }

  return (
    // @ts-ignore
    <SearchResultsModalRoot sx={{ ...managedContainerStyle, ...customStyle }}>
      <Hidden lgUp implementation="css">
        <Box sx={{ maxHeight: '400px', overflowY: 'auto' }}>{listBuilder()}</Box>
      </Hidden>
      <Hidden lgDown implementation="css">
        <Grid container>
          {isEmptyContent ? (
            <EmptySearchResultsContainer>
              <NoResultsComponent onClick={handleCloseSearch} />
            </EmptySearchResultsContainer>
          ) : (
            <>
              {!isAlternativeSearchTypesIncluded && (
                <>
                  <SearchModalItemContainer item>
                    <SearchResultsList
                      rootContainerStyles={{ padding: '16px 24px' }}
                      conditionsProcedures={data?.conditionsProcedures}
                      searchString={searchString}
                      bubbleView
                    />
                  </SearchModalItemContainer>
                  <SearchModalItemContainer item>
                    <SearchResultsList
                      rootContainerStyles={{ padding: '16px 24px' }}
                      specialties={data?.specialties}
                      searchString={searchString}
                      bubbleView
                    />
                  </SearchModalItemContainer>
                </>
              )}
              <SearchModalItemContainer item>
                <SearchResultsList
                  rootContainerStyles={{ padding: '8px 24px' }}
                  items={data?.profiles}
                  searchString={searchString}
                  specialistOrPractice
                  shouldShowProfiles
                />
              </SearchModalItemContainer>
            </>
          )}
        </Grid>
      </Hidden>
    </SearchResultsModalRoot>
  )
}

export default AutocompleteResultsModal
